module.exports = __webpack_public_path__ + "static/st-mock2-ef2af14fb6c8dd7022a3708108653b83.png";